import React, { useState } from "react";
import { apiService } from "../../services";

const VerifyCodeTestPage: React.FC = () => {
  const [prizeWinner, setPrizeWinner] = useState("");
  const [phone, setPhone] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [codesInput, setCodesInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<string>("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setResult("");
    try {
      const codes = codesInput
        .split(/[\n,]/)
        .map((s) => s.trim())
        .filter(Boolean);
      const resp = await apiService.verifyCode({
        prize_winner: prizeWinner,
        phone,
        api_key: apiKey,
        code: codes,
      });
      setResult(JSON.stringify(resp, null, 2));
    } catch (err: any) {
      setResult(err?.message || "Request failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Test Verify Code</h1>
      <form onSubmit={handleSubmit} className="space-y-4 max-w-2xl">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Họ tên người trúng
          </label>
          <input
            value={prizeWinner}
            onChange={(e) => setPrizeWinner(e.target.value)}
            className="w-full border rounded px-3 py-2"
            placeholder="Nguyen Van A"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Số điện thoại
          </label>
          <input
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className="w-full border rounded px-3 py-2"
            placeholder="0898xxxxxx"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            API Key
          </label>
          <input
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
            className="w-full border rounded px-3 py-2"
            placeholder="abc123xyz"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Codes (ngăn cách bằng dấu phẩy hoặc xuống dòng)
          </label>
          <textarea
            value={codesInput}
            onChange={(e) => setCodesInput(e.target.value)}
            className="w-full border rounded px-3 py-2"
            rows={4}
            placeholder={"CODE001, CODE002"}
            required
          />
        </div>
        <div className="flex items-center space-x-2">
          <button
            type="submit"
            disabled={loading}
            className="px-4 py-2 rounded bg-blue-600 text-white disabled:opacity-50"
          >
            {loading ? "Đang gọi API..." : "Gửi verify"}
          </button>
        </div>
      </form>

      {result && (
        <div className="mt-6">
          <h2 className="font-semibold mb-2">Kết quả</h2>
          <pre className="bg-gray-900 text-green-300 p-4 rounded overflow-auto text-sm">
            {result}
          </pre>
        </div>
      )}
    </div>
  );
};

export default VerifyCodeTestPage;
